// components/PoolHeader.js
import React from "react";
import { useTheme } from "../../../hooks/ThemeProvider";

const PoolHeader = ({ onShare, rootPoolData }) => {
      const { theme, toggle } = useTheme();
    const metadata = rootPoolData?.metadata || {};

    // Social links mapping
  const socials = [
  {
    key: "twitter",
    icon: theme === "dark" ? "/assets/x.svg" : "/assets/lightx.svg",
    link: rootPoolData?.socials?.twitter?.replace("@", ""),
  },
  {
    key: "instagram",
    icon: theme === "dark" ? "/assets/insta.svg" : "/assets/lightin.svg",
    link: rootPoolData?.socials?.instagram?.replace("@", ""),
  },
  {
    key: "discord",
    icon: theme === "dark" ? "/assets/dis.svg" : "/assets/lightdis.svg",
    link: rootPoolData?.socials?.discord,
  },
  {
    key: "website",
    icon: theme === "dark" ? "/assets/globe.svg" : "/assets/lightglo.svg",
    link: rootPoolData?.socials?.website?.startsWith("http")
      ? rootPoolData?.socials?.website
      : `https://${rootPoolData?.socials?.website}`,
  },
];

    // console.log(socials)

    const renderSocials = () =>
        socials
            .filter(s => rootPoolData?.socials?.[s.key]) // only show if exists
            .map(s => (
                <a key={s.key} href={s.link} target="_blank" rel="noopener noreferrer">
                    <img src={s.icon} alt={s.key} />
                </a>
            ));

    return (
        <>
            <div className="top_future">
                <div className="inner_top">
                    <img
                        src={rootPoolData?.projectLogo || "/assets/logoinner.svg"}
                        alt="Logo"
                        className="imgdattta"
                    />
                    <h3>{rootPoolData?.projectName || "Pool"}</h3>
                </div>

                <div className="rightttside">
                    <button onClick={() => onShare(rootPoolData)}>
{
                theme === 'dark' ? <img src="/assets/share.svg" alt="Share" /> :
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
  <path d="M7 1.16669V8.75002" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M9.33366 3.50002L7.00033 1.16669L4.66699 3.50002" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M2.33301 7V11.6667C2.33301 11.9761 2.45592 12.2728 2.67472 12.4916C2.89351 12.7104 3.19026 12.8333 3.49967 12.8333H10.4997C10.8091 12.8333 11.1058 12.7104 11.3246 12.4916C11.5434 12.2728 11.6663 11.9761 11.6663 11.6667V7" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
              }


                        Share
                    </button>
                    {renderSocials()}
                </div>
            </div>

            <h2>{rootPoolData?.tagline || "TagLine"}</h2>
            <p>{rootPoolData?.poolDescription || "Description"}</p>

            {/* Mobile view */}
            <div className="phone__Side">
                <div className="rightttside">
                    <button onClick={() => onShare(rootPoolData)}>
                       {
                theme === 'dark' ? <img src="/assets/share.svg" alt="Share" /> :
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
  <path d="M7 1.16669V8.75002" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M9.33366 3.50002L7.00033 1.16669L4.66699 3.50002" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M2.33301 7V11.6667C2.33301 11.9761 2.45592 12.2728 2.67472 12.4916C2.89351 12.7104 3.19026 12.8333 3.49967 12.8333H10.4997C10.8091 12.8333 11.1058 12.7104 11.3246 12.4916C11.5434 12.2728 11.6663 11.9761 11.6663 11.6667V7" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
              }
                        Share
                    </button>
                    {renderSocials()}
                </div>
            </div>
        </>
    );
};

export default PoolHeader;
